import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import Ritual from './pages/Ritual';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import SafeIcon from './common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

function MainLayout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-200 selection:bg-amber-500/30 selection:text-amber-200 print:bg-white print:text-black">
      <header className="w-full p-6 border-b border-neutral-900/50 sticky top-0 bg-neutral-950/80 backdrop-blur-md z-20 print:hidden">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="font-serif text-lg tracking-widest text-neutral-400 hover:text-amber-500 transition-colors">
            THE COMMITMENT
          </Link>
          
          <nav className="flex gap-6 items-center">
            <Link 
              to="/" 
              className={`text-xs font-mono tracking-widest transition-colors flex items-center gap-2 ${
                location.pathname === '/' ? 'text-amber-500' : 'text-neutral-500 hover:text-neutral-300'
              }`}
            >
              <SafeIcon icon={FiIcons.FiPenTool} />
              RITUAL
            </Link>
            <Link 
              to="/admin" 
              className={`text-xs font-mono tracking-widest transition-colors flex items-center gap-2 ${
                location.pathname === '/admin' ? 'text-rose-500' : 'text-neutral-500 hover:text-neutral-300'
              }`}
            >
              <SafeIcon icon={FiIcons.FiDatabase} />
              ADMIN
            </Link>
          </nav>
        </div>
      </header>

      <main className="px-4 py-8 md:py-12 print:p-0 print:m-0 print:w-full">
        <Routes>
          <Route path="/" element={<Ritual />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <MainLayout />
    </BrowserRouter>
  );
}

export default App;